import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../css/dashboard.css";
import axios from 'axios';
import Pagination from "react-js-pagination";
import styled from "styled-components";

import CommonTable from "../component/table_list/common_table";
import CommonTableRow from "../component/table_list/common_tablerow";
import CommonTableColumn from "../component/table_list/common_tablecolumn";
import { useAuthContext } from '../common/ProtectedLayout';

function QuotationList(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const [isValidAccess, setIsValidAccess] = useState(false);
    const auth = useAuthContext();

    const [quotationList, setQuotationList] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(1);
    const ITEMS_PER_PAGE = 10;

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const fetchQuotationList = async () => {
        try {
            const offset = (page - 1) * ITEMS_PER_PAGE;
            const result = await axios.get(`/QuotationList/${offset}`);
            if (result.data.success) {
                setQuotationList(result.data.message);
            }
        } catch (error) {
            console.error('Error fetching quotation list:', error.message);
        }
    };

    const fetchTotalCount = async () => {
        try {
            const result = await axios.get('/QuotationCount');
            if (result.data.success) {
                setTotalCount(result.data.message);
            }
        } catch (error) {
            console.error('Error fetching quotation count:', error.message);
        }
    };

    const handleRowClick = (idx) => {
        navigate('/quotation_detail', {
            state: {
                idx: idx,
                beforePage: '/quotation_list'
            }
        });
    };

    useEffect(() => {
        setIsValidAccess(true);
        fetchTotalCount();
    }, []);

    useEffect(() => {
        fetchQuotationList();
    }, [page]);

    if (!isValidAccess) {
        return null;
    }

    return (
        <div style={{ padding: '20px' }}>
            <div className="w90p" style={{ marginTop: '40px', margin: '0 auto', position: 'relative' }}>
                <PageTitle>견적서 관리</PageTitle>
            </div>
            <div style={{ marginTop: '5px' }}>
                <CommonTable headerTitle={['No', '견적번호', '작성자', '회사명', '주소', '종목', '총액', '작성일']}>
                    {quotationList.map((item, index) => (
                        <ClickableRow
                            key={item.idx}
                            onClick={() => handleRowClick(item.idx)}
                        >
                            <CommonTableColumn>{totalCount - ((page - 1) * ITEMS_PER_PAGE) - index}</CommonTableColumn>
                            <CommonTableColumn>{item.quotation_number}</CommonTableColumn>
                            <CommonTableColumn>{item.staff_id}</CommonTableColumn>
                            <CommonTableColumn>{item.company_name || '-'}</CommonTableColumn>
                            <CommonTableColumn>
                                {item.address && item.address.length > 20
                                    ? item.address.substring(0, 20) + "..."
                                    : item.address || '-'}
                            </CommonTableColumn>
                            <CommonTableColumn>{item.jongmok || '-'}</CommonTableColumn>
                            <CommonTableColumn>{item.total_amount?.toLocaleString() || 0}원</CommonTableColumn>
                            <CommonTableColumn>{item.created_date ? item.created_date.substring(0, 10) : '-'}</CommonTableColumn>
                        </ClickableRow>
                    ))}
                </CommonTable>
            </div>
            <PaginationBox>
                <Pagination
                    activePage={page}
                    itemsCountPerPage={ITEMS_PER_PAGE}
                    totalItemsCount={totalCount}
                    pageRangeDisplayed={10}
                    onChange={handlePageChange}
                />
            </PaginationBox>
        </div>
    );
}

export default QuotationList;

const PageTitle = styled.h2`
    font-size: 1.5rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 20px;
`;

const ClickableRow = styled.tr`
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #f5f9ff;
    }
`;

const PaginationBox = styled.div`
    .pagination { display: flex; justify-content: center; margin-top: 15px; }
    ul { list-style: none; padding: 0; }
    ul.pagination li {
        display: inline-block;
        width: 30px;
        height: 30px;
        border: 1px solid #e2e2e2;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
    }
    ul.pagination li:first-child { border-radius: 5px 0 0 5px; }
    ul.pagination li:last-child { border-radius: 0 5px 5px 0; }
    ul.pagination li a { text-decoration: none; color: #337ab7; font-size: 1rem; }
    ul.pagination li.active a { color: white; }
    ul.pagination li.active { background-color: #337ab7; }
    ul.pagination li a:hover,
    ul.pagination li a.active { color: blue; }
`;
